import { FirebaseError } from 'firebase/app';
import { AppError, AuthError, DatabaseError } from './types';

export function handleAuthError(error: unknown): AuthError {
  if (error instanceof AuthError) {
    return error;
  }

  if (error instanceof FirebaseError && error.code.startsWith('auth/')) {
    return new AuthError(getAuthErrorMessage(error.code), { originalError: error });
  }

  return new AuthError('Authentication failed', { originalError: error });
}

export function handleDatabaseError(error: unknown): DatabaseError {
  if (error instanceof DatabaseError) {
    return error;
  }

  if (error instanceof FirebaseError && error.code.startsWith('firestore/')) {
    return new DatabaseError('Database operation failed', { originalError: error });
  }

  return new DatabaseError('Database operation failed', { originalError: error });
}

function getAuthErrorMessage(code: string): string {
  const messages: Record<string, string> = {
    'auth/email-already-in-use': 'An account with this email already exists',
    'auth/invalid-email': 'Invalid email address',
    'auth/operation-not-allowed': 'Operation not allowed',
    'auth/weak-password': 'Password is too weak',
    'auth/user-disabled': 'This account has been disabled',
    'auth/user-not-found': 'No account found with this email',
    'auth/wrong-password': 'Incorrect password',
    'auth/popup-closed-by-user': 'Sign in was cancelled',
    'auth/cancelled-popup-request': 'Sign in was cancelled',
    'auth/popup-blocked': 'Sign in popup was blocked by your browser',
  };

  return messages[code] || 'Authentication failed';
}